import React, {
  useEffect,
} from 'react';

const GanttGrid = ({
  onBarsDragged,
  onBarsClicked,
  hasSizeControls,
  areBarsDraggable,
  colSize,
  colCount,
  colOffset,
  barCount = 3, // TODO: Remove after dev
}) => {
  const columns = [];
  const paths = [];
  const gridHeight = colSize * barCount;
  const gridWidth = colSize * colCount;
  
  for (let i = 0; i < colCount; i++) {
    /* Vertical stripes
    columns.push(
      <rect
        x={colSize * i}
        y="0"
        width={colSize}
        height={gridHeight}
        style={{
          fill: i % 2 ? '#eee' : '#f8f8f8',
        }}
      />
    );
    */
  
    paths.push(
      <path
        key={`${i}`}
        style={{stroke: '#e0e0e0', strokeWidth: '0.2'}} 
        d={`M ${colSize * i} 0 V ${gridHeight}`} 
      />
    );
  }
    
  for (let i = 0; i < barCount; i++) {
    columns.push(
      <rect
        key={`${i}`}
        x="0"
        y={colSize * i}
        width={gridWidth}
        height={colSize}
        style={{
          fill: i % 2 ? '#f5f5f5' : '#fff',
        }}
      />
    );
  }
  
  paths.push([
    <path
      key={`gantt-grid-horz-bottom`}
      style={{stroke: '#e0e0e0', strokeWidth: '1'}} 
      d={`M 0 ${gridHeight} H ${gridWidth}`} 
    />,
    <path 
      key={`gantt-grid-horz-top`}
      style={{stroke: '#e0e0e0', strokeWidth: '1'}} 
      d={`M 0 0 H ${gridWidth}`} 
    />,
  ]);
  
  return (
    <svg
      height={colSize * barCount}
      width={colSize * colCount}
      x="0"
      y={colSize * 2}
      style={{
        position: 'absolute',
        overflow: 'visible'
      }}
    >
      {columns}
      {paths}
    </svg>
  );
};

export default GanttGrid;
